import { UserGatewayMessage } from '../../../../types/UserGatewayMessage';
import { UserStatus } from '../../../../types/UserStatus';
import { Tag } from '../../../cdl/Tag/Tag';
import { Text } from '../../../cdl/Text/Text';
import { translate } from '../../../common/helpers/translate.helper';
import { Characters } from '../../../common/helpers/unicode.helper';
import { useEnums } from '../../../common/hooks/useEnums';
import { useRole } from '../../../common/hooks/useRole';
import { Box } from '../../../common/ui/Box';

interface MemberNameCellProps {
    user: UserGatewayMessage;
}

export const MemberNameCell = ({ user }: MemberNameCellProps) => {
    const role = useRole();
    const { getHumanReadableValue } = useEnums();

    const name = [user.firstname, user.lastname].filter(Boolean).join(' ').trim() || Characters.EN_DASH;

    const getStatusTag = () => {
        if (role.user.id === user.id) {
            return (
                <Tag variant="default" emphasis>
                    {translate('user.you')}
                </Tag>
            );
        }
        if (user.status === UserStatus.INVITED) {
            return <Tag variant="accent">{getHumanReadableValue('status', UserStatus.INVITED)}</Tag>;
        }
        if (user.status === UserStatus.INACTIVE) {
            return <Tag variant="default">{getHumanReadableValue('status', UserStatus.INACTIVE)}</Tag>;
        }
        return null;
    };

    return (
        <Box display="flex" alignItems="center" gap={4}>
            {name ? <Text fontWeight={600}>{name}</Text> : null}
            {getStatusTag()}
            {user.ssoEnabled ? <Tag variant="default">{translate('user.ssoManaged')}</Tag> : null}
        </Box>
    );
};
